import http from "../../http";

/**
 * 平台分账方案（跨店）
 * 网关前缀：/gateway/api/sycompany/pc/profitPlan
 */
const profitPlan = {
    page(r) {
        return http.get("/gateway/api/sycompany/pc/profitPlan/page", r)
    },
    list(r) {
        return http.get("/gateway/api/sycompany/pc/profitPlan/list", r)
    },
    detail(r) {
        return http.get("/gateway/api/sycompany/pc/profitPlan/detail", r)
    },
    /** 某店当前生效分账（扫码 + 商品） */
    activeByCompany(r) {
        return http.get("/gateway/api/sycompany/pc/profitPlan/activeByCompany", r)
    },
    saveMeta(r) {
        return http.confirm.payload("/gateway/api/sycompany/pc/profitPlan/saveMeta", r)
    },
    forkVersion(r) {
        return http.confirm.post("/gateway/api/sycompany/pc/profitPlan/forkVersion", r)
    },
    saveItem(r) {
        return http.confirm.payload("/gateway/api/sycompany/pc/profitPlan/saveItem", r)
    },
    deleteItem(r) {
        // 页面已自行二次确认，勿再用 http.confirm（嵌套 Modal 会导致请求发不出去）
        return http.post("/gateway/api/sycompany/pc/profitPlan/deleteItem", r)
    },
    reorderItems(versionId, itemIds) {
        return http.confirm.payload(`/gateway/api/sycompany/pc/profitPlan/reorderItems?versionId=${encodeURIComponent(versionId)}`, itemIds)
    },
    publish(r) {
        return http.confirm.payload("/gateway/api/sycompany/pc/profitPlan/publish", r)
    },
    switchVersion(r) {
        return http.confirm.payload("/gateway/api/sycompany/pc/profitPlan/switchVersion", r)
    },
    disablePlan(r) {
        return http.confirm.post("/gateway/api/sycompany/pc/profitPlan/disablePlan", r)
    },
    deletePlan(r) {
        return http.confirm.post("/gateway/api/sycompany/pc/profitPlan/deletePlan", r)
    },
    preview(r) {
        return http.payload("/gateway/api/sycompany/pc/profitPlan/preview", r)
    },
    importFromChannel(r) {
        return http.confirm.post("/gateway/api/sycompany/pc/profitPlan/importFromChannel", r)
    },
    pointOptions(r) {
        return http.get("/gateway/api/sycompany/pc/profitPlan/pointOptions", r)
    },
    channelOptions(r) {
        return http.get("/gateway/api/sycompany/pc/profitPlan/channelOptions", r)
    },
    bookAccountList(r) {
        return http.get("/gateway/api/sycompany/pc/profitPlan/bookAccount/list", r)
    },
    saveBookAccount(r) {
        return http.confirm.payload("/gateway/api/sycompany/pc/profitPlan/bookAccount/save", r)
    },
    goodsOptions(r) {
        return http.get("/gateway/api/sycompany/pc/profitPlan/goodsOptions", r)
    },
    categoryOptions(r) {
        return http.get("/gateway/api/sycompany/pc/profitPlan/categoryOptions", r)
    },
    /** 店铺慈善记录（/companyIndex 慈善记录），供分账慈善规则关联；支付成功后 syncPaySuccess 用 companyCharityId 调三方 */
    charityOptions(r) {
        return http.get("/gateway/api/sycompany/pc/charity/page", {
            companyId: r && r.companyId,
            page: 1,
            pageSize: 500
        })
    },
}

export default profitPlan
